export default __webpack_public_path__ + "static/Wintomato_1200x400-673b1635f87b8eef59307061da6c8752.png";